import { useReCaptcha } from 'vue-recaptcha-v3'
/**
 * The exported executeRecaptcha function allows
 * you to execute reCAPTCHA actions
 * and retrieve the reCAPTCHA token along with the header options
 * to be used in subsequent requests.
 */
export function useGoogleRecaptcha (){
  const recaptchaInstance = useReCaptcha()
  const siteKey = useRuntimeConfig().public.googleRecaptchaSiteKey
  const executeRecaptcha = async action => {
    // No site key configured: there is no token to be had, so ask for none.
    //
    // This matters because of what the API does with the answer. It skips
    // verification entirely when no token arrives outside release mode, but
    // verifies whatever DOES arrive — so a local environment sending a token
    // minted from one key pair, to a server holding another, fails every
    // sign-up with "Please prove you are not a robot" and no way to get past
    // it. Sending nothing is the honest signal, and the one the server
    // already knows how to read.
    if (!siteKey) return {token: null, headerOptions: {headers: {}}}

    /**
     * Wait for the recaptchaInstance to be loaded
     * by calling the recaptchaLoaded method.
     * This ensures that the reCAPTCHA library is fully loaded
     * and ready to execute reCAPTCHA actions.
     */
    await recaptchaInstance?.recaptchaLoaded()
    const token = await recaptchaInstance?.executeRecaptcha(action)
    const headerOptions = {
      headers: {
        'google-recaptcha-token': token
      }
    }
    return { token, headerOptions }
  }
  return { executeRecaptcha }
}

